"use client"

import { useState, useEffect } from "react"
import Logo from "../../images/Logo.png"
import iiche75 from "../../images/iiche75.jpg"
import { collection, getDocs } from "firebase/firestore"
import { db } from "../../firebase"
import Logoiiche from "../../images/logoiiche.png"
import { Link } from "react-router-dom"
import "./Eventcard.css"

const ContentWithImage = () => {
  const [events, setEvents] = useState([])

  const redirectToRegistration = () => {
    window.location.href = "https://www.iiche.org.in/student/index.php"
  }

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const eventsRef = collection(db, "events")
        const snapshot = await getDocs(eventsRef)
        const eventData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        // Sort by createdAt in descending order (newest first) and take the first 3
        const sortedEvents = eventData.sort((a, b) => {
          const dateA = a.createdAt?.toDate?.() || new Date(a.createdAt) || new Date(0)
          const dateB = b.createdAt?.toDate?.() || new Date(b.createdAt) || new Date(0)
          return dateB - dateA // Descending order (newest first)
        })
        setEvents(sortedEvents.slice(0, 3)) // Take the first 3 (most recent)
      } catch (error) {
        console.error("Error fetching events:", error)
      }
    }

    fetchEvents()
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-800 relative overflow-hidden">
      {/* Floating Background Elements */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-gradient-to-r from-green-400 to-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-float"></div>
      <div className="absolute top-40 right-10 w-96 h-96 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-float animation-delay-2000"></div>
      <div className="absolute bottom-20 left-1/2 w-96 h-96 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-float animation-delay-4000"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 py-16">
        {/* Hero Section */}
        <section className="text-center mb-20">
          <div className="flex flex-col lg:flex-row items-center justify-center mb-12 space-y-8 lg:space-y-0 lg:space-x-12">
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-blue-500 rounded-full blur-lg opacity-30 group-hover:opacity-50 transition-opacity duration-300"></div>
              <img
                src={Logo || "/placeholder.svg"}
                alt="IIChE Logo"
                className="relative w-64 h-64 md:w-80 md:h-80 rounded-full shadow-2xl transform transition-transform duration-500 hover:scale-110 hover:rotate-3"
              />
            </div>

            <div className="text-left max-w-2xl">
  <h1 className="text-3xl md:text-3xl lg:text-4xl font-bold leading-tight mb-6" style={{ color: 'rgb(76, 182, 159)' }}>
    <b style={{ color: '#9acd32' }}>I</b>ndian <b style={{ color: 'yellowgreen' }}>I</b>nstitute of{" "}
    <b style={{ color: 'yellowgreen' }}>Ch</b>emical <b style={{ color: 'yellowgreen' }}>E</b>ngineers
    <br />
    <b style={{ color: 'yellowgreen' }}>A</b>mrita <b style={{ color: 'yellowgreen' }}>V</b>ishwa{" "}
    <b style={{ color: 'yellowgreen' }}>V</b>idyapeetham <b style={{ color: 'yellowgreen' }}>U</b>niversity
    <br />
    <b style={{ color: 'yellowgreen' }}>S</b>tudent <b style={{ color: 'yellowgreen' }}>C</b>hapter
  </h1>
</div>
</div>

          <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/20 p-8 mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-green-600 via-blue-600 to-purple-600 bg-clip-text text-transparent mb-6">
              "Fueled by Passion, Driven by Students"
            </h2>
            <p className="text-lg md:text-xl lg:text-2xl text-gray-700 dark:text-gray-300 leading-relaxed max-w-5xl mx-auto">
              Welcome to our IIChE Student Chapter, where innovation meets leadership. Together, we forge the future of
              Chemical Engineering, cultivating a dynamic community of aspiring professionals. Join us in the journey of
              excellence, where students shape the narrative and redefine the possibilities in our field.
            </p>
          </div>
        </section>

        {/* About IIChE Section */}
        <section className="mb-20">
          <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/20 p-8 md:p-12">
            <div className="text-center mb-12">
              <h3 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent mb-6">
                About IIChE
              </h3>
              <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-green-500 mx-auto rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
              {/* Left Image */}
              <div className="flex justify-center lg:justify-start">
                <div className="relative group">
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-green-500 rounded-2xl blur-lg opacity-30 group-hover:opacity-50 transition-opacity duration-300"></div>
                  <img
                    src={iiche75 || "/placeholder.svg"}
                    alt="IIChE 75 Years"
                    className="relative w-64 h-auto md:w-80 md:h-auto rounded-2xl shadow-xl transform transition-transform duration-500 hover:scale-105"
                  />
                </div>
              </div>

              {/* Center Content */}
              <div className="lg:col-span-1 text-center">
                <div className="bg-gradient-to-r from-blue-50 to-green-50 dark:from-blue-900/20 dark:to-green-900/20 rounded-2xl p-6 border border-blue-200 dark:border-blue-700">
                  <p className="text-gray-700 dark:text-gray-300 text-base md:text-lg leading-relaxed text-justify">
                    The Indian Institute of Chemical Engineers serves as a convergence point for professionals hailing
                    from academia, research institutes, and industry. While adapting proactively to the dynamic needs of
                    society and the economy, its fundamental objectives have remained steadfast since its inception. The
                    overarching vision is to propel the advancement of Chemical Engineering Science and formulate a code
                    of ethics within the profession.
                  </p>
                  <div className="mt-6 p-4 bg-white/50 dark:bg-gray-800/50 rounded-xl">
                    <p className="text-gray-600 dark:text-gray-400 text-sm md:text-base leading-relaxed">
                      Facilitating continuous interaction and idea exchange with chemical engineering professionals in
                      India and across borders is a primary focus. The IIChE maintains robust connections with various
                      professional bodies globally and has collaborative agreements with esteemed institutions such as
                      the Institution of Chemical Engineers in the UK, the American Institute of Chemical Engineers
                      (AIChE) in the USA, the Canadian Institute of Chemical Engineers (CSChE) in Canada, and the
                      Society of Chemical Engineers, Japan (SCEJ).
                    </p>
                  </div>
                </div>
              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <div className="relative group">
                  <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-blue-500 rounded-2xl blur-lg opacity-30 group-hover:opacity-50 transition-opacity duration-300"></div>
                  <img
                    src={Logoiiche || "/placeholder.svg"}
                    alt="IIChE Official Logo"
                    className="relative w-64 h-auto md:w-80 md:h-auto rounded-2xl shadow-xl transform transition-transform duration-500 hover:scale-105"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Events Section */}
        <section className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
              Latest Events
            </h3>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {events.map((event, index) => (
              <Link
                to={`/readmore/${event.id}`}
                key={event.id}
                className="group bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg rounded-2xl shadow-xl border border-white/20 overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:scale-105 hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="relative overflow-hidden">
                  <img
                    className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                    src={event.image || "/placeholder.svg"}
                    alt={event.Heading}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-800 dark:text-white mb-3 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-purple-600 group-hover:to-pink-600 group-hover:bg-clip-text transition-all duration-300">
                    {event.Heading}
                  </h4>
                  <p className="text-gray-600 dark:text-gray-400 line-clamp-3">{event.paragraph}</p>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/events"
              className="group inline-flex items-center px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-bold rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
            >
              <span className="mr-2">View All Events</span>
              <svg
                className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        </section>

        {/* Registration Section */}
        <section>
          <div className="bg-gradient-to-r from-green-500 via-blue-500 to-purple-500 rounded-3xl shadow-2xl p-8 md:p-12 text-white text-center">
            <h3 className="text-3xl md:text-4xl font-bold mb-6">Student Membership Registration</h3>
            <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
              To become a member of IIChE-AVVU student chapter, follow the steps below:
            </p>

            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 mb-8 max-w-4xl mx-auto">
              <ol className="text-left space-y-3 text-lg">
                <li className="flex items-center">
                  <span className="bg-white/20 rounded-full w-8 h-8 flex items-center justify-center mr-4 font-bold">
                    1
                  </span>
                  Fill out the online registration form.
                </li>
                <li className="flex items-center">
                  <span className="bg-white/20 rounded-full w-8 h-8 flex items-center justify-center mr-4 font-bold">
                    2
                  </span>
                  Submit the required documents for verification.
                </li>
                <li className="flex items-center">
                  <span className="bg-white/20 rounded-full w-8 h-8 flex items-center justify-center mr-4 font-bold">
                    3
                  </span>
                  Pay the membership fee through the provided payment gateway.
                </li>
                <li className="flex items-center">
                  <span className="bg-white/20 rounded-full w-8 h-8 flex items-center justify-center mr-4 font-bold">
                    4
                  </span>
                  Download your membership confirmation PDF.
                </li>
                <li className="flex items-center">
                  <span className="bg-white/20 rounded-full w-8 h-8 flex items-center justify-center mr-4 font-bold">
                    5
                  </span>
                  Keep the PDF copy for future reference.
                </li>
              </ol>
            </div>

            <button
              className="group bg-white text-gray-800 font-bold py-4 px-8 rounded-2xl hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
              onClick={redirectToRegistration}
            >
              <span className="bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                Register Now
              </span>
            </button>
          </div>
        </section>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-20px) rotate(1deg); }
          66% { transform: translateY(-10px) rotate(-1deg); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  )
}

export default ContentWithImage
